import styled from 'styled-components'
import { Icon } from 'antd'
import { FlexContainer } from '@edulastic/common'
import { lightBlue7 } from '@edulastic/colors'
import { IconUpload as IconUp } from '@edulastic/icons'

export const Container = styled(FlexContainer)`
  min-height: 200px;
  width: ${({ theme }) => theme.styledDropZone.containerWidth || '100%'};
  height: ${({ theme, height }) =>
    height || theme.styledDropZone.containerHeight || '100%'};
  margin: ${({ theme, margin }) =>
    margin || theme.styledDropZone.containerMargin || '0px'};
  padding: ${({ theme }) => theme.styledDropZone.containerPadding || '0px'};
  border-radius: ${({ theme }) =>
    theme.styledDropZone.containerBorderRadius || '2px'};
  border: ${({ theme, isDragActive }) =>
    isDragActive
      ? `1px solid ${theme.styledDropZone.containerDragActiveColor}`
      : `1px dashed ${theme.styledDropZone.containerBorderColor}`};
  background: ${({ theme }) => theme.styledDropZone.containerBackground};
  &:focus {
    border: 1px solid
      ${({ theme }) =>
        theme.styledDropZone.containerFocusBorderColor || lightBlue7};
  }
  &:active {
    border: 1px solid
      ${({ theme }) =>
        theme.styledDropZone.containerFocusBorderColor || lightBlue7};
  }
  .dropzone-list-div {
    display: flex;
    flex-direction: column;
  }
  .dropzone-list-label {
    font-size: ${({ theme }) => theme.styledDropZone.zoneTitleFontSize};
    font-weight: ${({ theme }) => theme.styledDropZone.zoneTitleFontWeight};
  }
  .dropzone-list-item {
    margin-top: '2px';
    font-size: ${({ theme }) => theme.styledDropZone.zoneTitleCommentFontSize};
    font-weight: ${({ theme }) => theme.styledDropZone.zoneTitleFontWeight};
  }
`

export const IconUpload = styled(IconUp)`
  margin-bottom: 18px;
  width: ${({ theme }) => theme.styledDropZone.iconUploadWidth || '35px'};
  height: ${({ theme }) => theme.styledDropZone.iconUploadHeight || '30px'};
  fill: ${({ theme, isDragActive }) =>
    isDragActive
      ? theme.styledDropZone.iconUploadDragActiveColor
      : theme.styledDropZone.iconUploadColor};
  :hover {
    fill: ${({ theme, isDragActive }) =>
      isDragActive
        ? theme.styledDropZone.iconUploadDragActiveColor
        : theme.styledDropZone.iconUploadColor};
  }
`

export const Loading = styled(Icon)`
  font-size: ${({ theme }) => theme.styledDropZone.loadingIconFontSize};
`

export const Underlined = styled.span`
  color: ${({ theme }) => theme.styledDropZone.underlinedColor};
  cursor: pointer;
  text-decoration: underline;
`

export const ZoneTitle = styled.div`
  font-size: ${({ theme, textRole }) => {
    if (textRole === 'title') return '16px'
    if (textRole === 'or') return '14px'
    if (textRole === 'upload') return '16px'
    if (textRole === 'formats') return '12px'
    return theme.styledDropZone.zoneTitleFontSize
  }};
  font-weight: ${({ theme, textRole }) =>
    textRole === 'title' || textRole === 'upload'
      ? 600
      : textRole
      ? 400
      : theme.styledDropZone.zoneTitleFontWeight};
  text-transform: ${({ textRole }) => (textRole ? 'none' : 'uppercase')};
  color: ${({ theme, textRole }) => {
    if (textRole === 'upload') {
      return theme.styledDropZone.mediaUploadColor
    }
    if (textRole === 'or' || textRole === 'formats') {
      return theme.styledDropZone.mediaTextColor
    }
    if (textRole === 'title') {
      return theme.styledDropZone.mediaTitleColor
    }
    return theme.styledDropZone.zoneTitleColor
  }};
  margin-top: ${({ textRole }) => {
    if (textRole === 'or') return '16px'
    if (textRole === 'upload') return '12px'
    if (textRole === 'formats') return '16px'
    return 0
  }};
  line-height: ${({ textRole }) => (textRole ? 1.25 : 'normal')};
  text-decoration: ${({ textRole }) =>
    textRole === 'upload' ? 'underline' : 'none'};
  text-underline-offset: 4px;
`

export const WarningText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 56px;
  margin-top: 18px;
  margin-bottom: -20px;
  padding: 12px 16px;
  box-sizing: border-box;
  border-radius: 12px;
  background: ${({ theme }) =>
    theme.styledDropZone.mediaWarningBackgroundColor};
  font-size: 14px;
  line-height: 1.3;
  font-weight: 600;
  color: ${({ theme }) => theme.styledDropZone.mediaWarningTextColor};
  text-transform: none;
  text-align: left;
`

export const WarningIcon = styled(Icon)`
  margin-right: 10px;
  flex-shrink: 0;
  color: ${({ theme }) => theme.styledDropZone.mediaWarningIconColor};
  font-size: 16px;
`
